import {Synth} from './Synth'
import {GrooveBox} from './GrooveBox'
import {Piano} from './Piano'
import {Baix} from './Baix'
import {Sampler} from './Sampler'
import {SynthWam} from './SynthWam'
import {SynthBassWam} from './BaixWam'
import {PianoWam} from './PianoWam'
import {Looper} from './Looper'
import {PianoSoundFont} from './PianoSoundFont'

export default [
  Synth,
  GrooveBox,
  Piano,
  Baix,
  Sampler,
  SynthWam,
  SynthBassWam,
  PianoWam,
  PianoSoundFont,
  Looper
]